export default __webpack_public_path__ + "static/media/kayaguneriki6.216bc531.jpg";